import { useSetModal } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import { useTranslation } from "react-i18next";
import Nlflag from "../../../App/Assets/Icons/nlflag.svg";
import trFlag from "../../../App/Assets/Icons/trflag.svg";
import ukflag from "../../../App/Assets/Icons/ukflafg.svg";
import arFlag from "../../../App/Assets/Icons/arflag.svg";
import esFlag from "../../../App/Assets/Icons/spainflag.svg";
import deFlag from "../../../App/Assets/Icons/germanflag.svg";
import frFlag from "../../../App/Assets/Icons/frenchflag.svg";
import plFlag from "../../../App/Assets/Icons/polish.svg";
import ruFlag from "../../../App/Assets/Icons/russianflag.svg";
import zhCNFlag from "../../../App/Assets/Icons/chflag.svg";
import itFlag from "../../../App/Assets/Icons/italyflag.svg";
import hiFlag from "../../../App/Assets/Icons/indiaflag.svg";
import paFlag from "../../../App/Assets/Icons/indiaflag.svg";
import urFlag from "../../../App/Assets/Icons/pakistanflag.svg";
import srFlag from "../../../App/Assets/Icons/serbiaFlag.svg";
import jaFlag from "../../../App/Assets/Icons/japanFlag.svg";
import koFlag from "../../../App/Assets/Icons/koreaflag.svg";

export const flags = {  
  nl: Nlflag,
  tr: trFlag,
  en: ukflag,
  ar: arFlag,
  es: esFlag,
  de: deFlag,
  fr: frFlag,
  pl: plFlag,
  ru: ruFlag,
  zh: zhCNFlag,
  it: itFlag,
  hi: hiFlag,
  pa: paFlag,
  ur: urFlag,
  sr: srFlag,
  ja: jaFlag,
  ko: koFlag,
};

const KioskLanguage = ({ l = "" }) => {
  const t = useCommon();
  const { i18n } = useTranslation();
  const tEn = i18n.getFixedT("en");
  const flagSrc = flags[l as keyof typeof flags]; // Get the flag source if available
  const englishText = tEn(`languages.${l}`);
  const setModal = useSetModal();
  const handleClick = () => {
    i18n.changeLanguage(l);
    setModal("");
  };
  return (
    <div
      onClick={handleClick}
      className="flex cursor-pointer flex-col items-center justify-center gap-4 rounded-[1.5rem] p-[2rem_3rem]"
      style={{ background: "var(--grey)" }}
    >
      {flagSrc && (
        <img src={flagSrc} alt={`${l} flag`} className="block w-32 h-32 p-0" />
      )}
      {/* Display the flag if available */}
      <div className="text-[2rem]" style={{ fontWeight: "900" }}>
        {t(`languages.${l}`)} 
      </div>
      <div className="text-[1.75rem] text-[grey-blue]" style={{ fontWeight: "900" }}>
        {englishText}
      </div>
    </div>
  );
};

export default KioskLanguage;
